import React from "react";
import { Modal, Button } from "react-bootstrap";
import stopwatchIcon from "../../../assets/images/stopwatch 1.svg";

export default function TimeUp({
	isOpen, toggle, showResponse,
	title, message, buttonLabel, allowClose,submitDisable = false
}) {

	const submit = () => {
		if(submitDisable) return
		toggle();
		showResponse();
	}

	return (
		<>
		<style>
				{`
					.text-translate-modal .modal-content {
						border-radius: 16px !important;
					}
						.text-translate-modal .modal-header {
			border-bottom: none !important;
			position: relative;
		}
		.text-translate-modal .modal-header::after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 90%;
			height: 1px;
			background-color: #dee2e6;
		}
			.time-up {
  padding: 8px 8px;
  border-radius: 8px;
  background-color: #6155F514;
}
				`}
			</style>
		<Modal
		style={{borderRadius:"16px"}}
			centered
			show={isOpen}
			className="text-translate-modal "
        >
			<Modal.Header className="d-flex p-4 align-items-center">
				<img className="time-up me-3" src={stopwatchIcon} alt="Stopwatch Icon" />
				<Modal.Title className="text-translation popup_heading m-0">
				{title}
				</Modal.Title>
				{allowClose !== false &&
				<Button variant="link" className="modalClose-Btn p-0" style={{position:"relative" , right:"0" , top:"0" , backgroundColor:"#19181C1A" ,color:"#19181C"}} onClick={toggle}>
				<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	width="24"
	height="24"
>
	<path
	d="M18 6L6 18M6 6l12 12"
	stroke="currentColor"
	strokeWidth="2"
	strokeLinecap="round"
	strokeLinejoin="round"
	/>
</svg>
				</Button>}
			</Modal.Header>			
			<Modal.Body>
				<div className="row">
					<h2 className="translate-title">
						{message} <br /><br />
					</h2>

					<div >
						<button className="outline-btn" disabled={submitDisable} onClick={submit}>{buttonLabel}</button>
					</div>
				</div>
			</Modal.Body>
        </Modal>
		</>
	);
};